import { ReducerBuilder } from './reducerBuilder';
import { BookingsState } from 'acscp/store/bookingsState';
import { BaseGetRequest, BookingRequest, BookingsRequest, FlownBookingsRequest } from 'acscp/api/requests';
import { Booking } from 'acscp/api/models/booking';
import { BookingsList } from 'acscp/api/models/bookingsList';
import { Department } from 'acscp/api/models/customTypes/department';
import { BookingsFilter } from 'acscp/store';

const filterFlownBookingsFromBookingState = (state: BookingsState, action: 'include' | 'exclude') => {
    return Object.keys(state).reduce((acc, key) => {
        const bkg = state[key];
        if (action === 'include' ) {
            if (bkg.status === BookingsFilter.Flown) {
                acc[key] = state[key];
            }
        } else {
            if (bkg.status !== BookingsFilter.Flown) {
                acc[key] = state[key];
            }
        }
        return acc;
    }, {} as BookingsState);
};

export const bookingsReducer =
    new ReducerBuilder<BookingsState>({})
        .successfulRequestCase(BookingsRequest, (state, response: BookingsList) => {
            const storeBookings: BookingsState = filterFlownBookingsFromBookingState(state, 'include');
            for (const booking of response.bookings) {
                const processedBooking = {
                    ...booking,
                    legs: booking.legs.map(leg => ({ ...leg, bookingId: booking.id })),
                };
                storeBookings[booking.id] = processedBooking;
            }
            return storeBookings;
        })
        .successfulRequestCase(FlownBookingsRequest, (state, response: BookingsList) => {
            const storeBookings: BookingsState = filterFlownBookingsFromBookingState(state, 'exclude');
            for (const booking of response.bookings) {
                const processedBooking = {
                    ...booking,
                    legs: booking.legs.map(leg => ({ ...leg, bookingId: booking.id })),
                };
                storeBookings[booking.id] = processedBooking;
            }
            return storeBookings;
        })
        .successfulRequestCase<Booking, BaseGetRequest<Booking>>(BookingRequest, (state, bookingDetails) => {
            const storeBookingDetails = {
                ...bookingDetails,
                legs: bookingDetails.legs.map(l => ({
                    ...l,
                    bookingId: bookingDetails.id,
                }))
            };
            return {
                ...state,
                [bookingDetails.id]: storeBookingDetails
            };
        })
        .build();
